import { render, staticRenderFns } from "./ConfigOffersList.vue?vue&type=template&id=3a60a242&scoped=true"
import script from "./ConfigOffersList.vue?vue&type=script&lang=js"
export * from "./ConfigOffersList.vue?vue&type=script&lang=js"
import style0 from "./ConfigOffersList.vue?vue&type=style&index=0&id=3a60a242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a60a242",
  null
  
)

export default component.exports